import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { SeoService } from '../../shared/services/seo.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PartnersApplyService } from '@listique/api';

enum ApplicationStage {
    START,
    FORM,
    SENT
}

enum ApplicationFormStage {
    BUSINESS,
    SECTOR,
    CONTACT,
    CONTACT_SECONDARY,
    PACKAGE,
    SUBMISSION,
}
@Component({
    selector: 'app-apply',
    templateUrl: './apply.component.html',
    styleUrls: ['./apply.component.scss'],
})
export class ApplyComponent implements OnInit {
    applicationStageEnum = ApplicationStage;
    applicationStage: ApplicationStage = ApplicationStage.START;

    applicationFormStageEnum = ApplicationFormStage;
    applicationFormStage: ApplicationFormStage = ApplicationFormStage.BUSINESS;
    formSteps = [
        {
            id: ApplicationFormStage.BUSINESS,
            title: 'Business',
            active: true,
            completed: false,
            progress: false,
            secondary: false,
        },
        {
            id: ApplicationFormStage.SECTOR,
            title: 'Sector',
            active: false,
            completed: false,
            progress: false,
            secondary: false,
        },
        {
            id: ApplicationFormStage.CONTACT,
            title: 'Contact',
            active: false,
            completed: false,
            progress: false,
            secondary: true,
        },
        {
            id: ApplicationFormStage.PACKAGE,
            title: 'Package',
            active: false,
            completed: false,
            progress: false,
            secondary: false,
        },
        {
            id: ApplicationFormStage.SUBMISSION,
            title: 'Submission',
            active: false,
            completed: false,
            progress: false,
            secondary: false,
        },
    ];
    reviews = [
        {
            stars: 5,
            title: 'Outstanding Service',
            body:
                'Never have I dealt with such a friendly, dedicated team that that of Listique. They were there to help with my every need, Icouldn’t have asked for more. I’m so glad I signed up to be a member. Thank you so much!',
        },
        {
            stars: 5,
            title: 'What a find!',
            body:
                'Listique’s vast network of clients is just incredible. I’m so glad I found this unique service. Already company’s my ratings have boosted 20% in my first month of partnership. Wow.',
        },
        {
            stars: 5,
            title: 'Made Some Great Connections',
            body:
                'It’s so nice to have connected with other Private Staff on Listique’s Slack network. I’ve picked up so many tips, tricks and recommendations that I would never have done if it hadn’t been for Listique.',
        },
        {
            stars: 5,
            title: 'Incredible Range of Services',
            body:
                'I visited the website looking for the best concierge service in town. I left having signed up to a membership, and since then I have found multitudes of other top-of-the-range services. Listique truly do list the best.',
        },
    ];
    applicationForm = this.fb.group({
        businessName: [null, Validators.required],
        businessDescription: [null, Validators.required],
        contactName: [null, Validators.required],
        contactPhoneNumber: [null, Validators.required],
        contactEmailAddress: [null, Validators.email],
        websiteUrl: [null, Validators.required],
        partnershipOption: ['presidential', Validators.required],
        recaptchaKey: [null]
    });
    applicationFormSending = false;
    applicationFormError = null;
    @ViewChild('invisibleRecaptcha') invisibleRecaptcha: any;
    constructor(private fb: FormBuilder, private seoService: SeoService, private snackbar: MatSnackBar, private partnersApplyService: PartnersApplyService) { }

    ngOnInit() {
        this.seoService.generateTags('/apply');
    }

    changeApplicationStage(stage: ApplicationStage) {
        this.applicationStage = stage;
    }

    changeApplicationFormStage(stage: ApplicationFormStage, secondary = false, control?: FormControl) {
        if (control && !control.valid) {
            return false;
        }
        if (
            this.applicationFormStage === ApplicationFormStage.CONTACT_SECONDARY
        ) {
            this.applicationFormStage = ApplicationFormStage.CONTACT;
            const formStep = this.formSteps.find(
                step => step.id === this.applicationFormStage,
            );
            formStep.progress = false;
        }
        if (stage === ApplicationFormStage.CONTACT && secondary) {
            const formStep = this.formSteps.find(
                step => step.id === this.applicationFormStage,
            );
            formStep.progress = true;
            this.applicationFormStage = ApplicationFormStage.CONTACT_SECONDARY;
        } else {
            const formStep = this.formSteps.find(
                step => step.id === this.applicationFormStage,
            );
            formStep.active = false;
            formStep.completed = true;
            const formStepNew = this.formSteps.find(step => step.id === stage);
            formStepNew.active = true;
            this.applicationFormStage = stage;
            if (this.applicationFormStage === ApplicationFormStage.PACKAGE) {
                this.reviews = [];
            }
        }
    }

    submitApplication() {
        if (!this.applicationForm.valid ||
            !this.applicationFormSending) {
            this.applicationFormSending = true;
            this.invisibleRecaptcha.execute();
        }
    }

    recaptchaSuccess() {
        if (this.applicationForm.get('recaptchaKey').value !== null) {
            this.partnersApplyService.send(this.applicationForm.value).subscribe(
                result => {
                    // CLOSE FORM
                    this.applicationFormSending = false;
                    this.applicationStage = ApplicationStage.SENT;
                    this.snackbar.open('We\'ve sent your request to the partner and they will be in touch shortly', null, { duration: 5000 });
                },
                error => {
                    console.error(error);
                    this.applicationFormError = 'There was an error sending your application, please try again';
                    this.applicationFormSending = false;
                }
            );
        }
    }
}
